import * as setupIntent from './setupIntent';

export default {
  ...setupIntent,
};
